import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Logo } from '../components/Logo';

// Shared shell for /legal/* pages — narrow column, clean typography.
export function LegalLayout({ title, lastUpdated, children }) {
    return (
        <div className="grain legal-page" style={{ minHeight: '100vh', background: 'var(--bg)' }}>
            <header style={{
                position: 'sticky', top: 0, zIndex: 10,
                padding: '0.9rem 0', borderBottom: '1px solid var(--border)',
                background: 'rgba(10,10,10,0.85)', backdropFilter: 'blur(14px)',
            }}>
                <div className="container-x" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                    <Logo size="md" />
                    <Link to="/" className="btn btn-ghost btn-sm">
                        <ArrowLeft size={15} /> Înapoi
                    </Link>
                </div>
            </header>
            <main className="container-x" style={{ maxWidth: 820, padding: '2.5rem 1.2rem 4rem' }}>
                <div className="kicker">Document legal</div>
                <h1 className="headline" style={{ fontSize: 'clamp(1.8rem, 5vw, 2.6rem)', margin: '0.4rem 0 0.4rem' }}>{title}</h1>
                <div style={{ color: 'var(--text-faint)', fontSize: '0.85rem', marginBottom: '2rem' }}>
                    Ultima actualizare: {lastUpdated}
                </div>
                <div className="legal-content">
                    {children}
                </div>
                <div style={{ marginTop: '3rem', padding: '1.2rem', background: 'var(--surface-2)', borderRadius: 12, fontSize: '0.86rem', color: 'var(--text-muted)' }}>
                    <strong style={{ color: '#fff', display: 'block', marginBottom: 6 }}>Întrebări?</strong>
                    Scrie-ne la <a href="mailto:contact@clickmeniu.com" style={{ color: 'var(--amber)' }}>contact@clickmeniu.com</a> — îți răspundem în maxim 48 ore lucrătoare.
                </div>
                <nav style={{ marginTop: '2rem', display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center', fontSize: '0.85rem' }}>
                    <Link to="/legal/terms" style={{ color: 'var(--text-muted)' }}>Termeni și Condiții</Link>
                    <span style={{ color: 'var(--text-faint)' }}>·</span>
                    <Link to="/legal/privacy" style={{ color: 'var(--text-muted)' }}>Confidențialitate</Link>
                    <span style={{ color: 'var(--text-faint)' }}>·</span>
                    <Link to="/legal/cookies" style={{ color: 'var(--text-muted)' }}>Cookies</Link>
                </nav>
            </main>
        </div>
    );
}

// Operator info — single source of truth for legal pages.
// SCHIMBĂ AICI dacă-ți schimbi firma / sediul.
export const OPERATOR = {
    legal_name: 'BURLIX S.R.L.',
    cui: 'RO53847538',
    reg_com: 'J2026008650003',
    address: 'Drm. Gura Putnei nr. 45, Bl. 2, Et. 2, Ap. 18, Sector 3, București',
    email: 'contact@clickmeniu.com',
    platform: 'clickmeniu.ro',
};
